import BaseModel from './BaseModel';
import ApiErrorResponseValidation from '../../types/models/apiErrorResponseValidation';

class ErrorModel extends BaseModel {
  public validations: ApiErrorResponseValidation[];
  public message: {
    type?: string | null;
    code?: string | null | Record<string, unknown>;
    name?: string | null;
    description?: string | null;
    validations?: ApiErrorResponseValidation[] | null;
  };
  public detail?: string | null;
  public fieldErrors: Record<string, string[]> | null;

  constructor(arg: any) {
    super(arg);
    if (arg) this.validations = arg.message?.validations || arg.validations || [];
    else this.validations = [];
    this.message = arg.message;
    this.detail = arg.detail;
    this.fieldErrors = null;

    // Vitrin validation errors are returned in field-error format
    // -- just and object with field names as keys and array of strings as values--
    // so, we need to convert them to validations format.
    if (this.isFieldErrorFormat(arg)) {
      this.fieldErrors = arg;
      this.validations = this.convertFieldErrorsToValidations(arg);
    }
  }
  private isFieldErrorFormat(arg: any): boolean {
    if (!arg || typeof arg !== 'object' || Array.isArray(arg)) {
      return false;
    }
    const keys = Object.keys(arg);
    const standardKeys = ['message', 'detail', 'validations', 'type', 'code'];
    const hasOnlyFieldKeys = keys.every((key) => !standardKeys.includes(key));
    const hasArrayValues = keys.some(
      (key) => Array.isArray(arg[key]) && arg[key].every((item: any) => typeof item === 'string'),
    );

    return hasOnlyFieldKeys && hasArrayValues && keys.length > 0;
  }

  private convertFieldErrorsToValidations(fieldErrors: Record<string, string[]>): ApiErrorResponseValidation[] {
    const validations: ApiErrorResponseValidation[] = [];
    for (const [field, errors] of Object.entries(fieldErrors)) {
      if (Array.isArray(errors)) {
        validations.push({
          field,
          errors,
        });
      }
    }

    return validations;
  }

  /**
   * Prefer field validation errors, then message description / detail, then fallback.
   */
  public getDisplayMessage(fallback = 'Something went wrong'): string {
    const validationMessage = this.validations?.[0]?.errors?.[0];
    if (validationMessage) {
      return validationMessage;
    }
    return this.message?.description || this.detail || fallback;
  }
}

export default ErrorModel;
